<h1> CONTATTI </h1>
<div class="text">
	<h2>Amministrazione</h2>
	<p>
		Presidente: <a href="mailto:presidente@decifris.it">presidente&#64;decifris.it</a>.
		<br>
		Segreteria: <a href="mailto:segreteria@decifris.it"> segreteria&#64;decifris.it</a>.
		<br>
		Gestione soci: <a href="mailto:soci@decifris.it">soci&#64;decifris.it</a>.
		<br>
		PEC: <a href="mailto:soci@decifris.it">decifris&#64;pec.it</a>.
	</p>
	<h2>Corsi e formazione</h2>
	<p>
		Corsi <i>De Cifris Trends</i>: <a href="mailto:trends@decifris.it">trends&#64;decifris.it</a>.
		<br>
		Corsi <i>De Cifris Young2Young</i>: <a href="mailto:y2y@decifris.it">y2y&#64;decifris.it</a>.
		<br>
		Formazione: <a href="mailto:formazione@decifris.it">formazione&#64;decifris.it</a>.
		<br>
		Eventi: <a href="mailto:eventi@decifris.it">eventi&#64;decifris.it</a>.
	</p>
	<h2>Sito web</h2>
	<p>Gestione sito web: <a href="mailto:webmaster@decifris.it">webmaster&#64;decifris.it</a>.</p>
</div>

<a href="https://www.youtube.com/channel/UCTgLUneI3agkv_FcW0RlI0A" title="La nostra pagina YouTube" target="_blank">
	<i class="fab fa-youtube fa-2x mr-3"></i></a>
<a href="https://www.linkedin.com/in/de-componendis-cifris-iniziativa-nazionale-8274501a5/"
	title="La nostra pagina LinkedIn" target="_blank">
	<i class="fab fa-linkedin-square fa-2x ml-3"></i>
</a>
<p>
	De Componendis Cifris APS - Via Zuretti, 34 - 20125 Milano (MI)
	<br>
	CF: 97937880157 - P.IVA: 12816760966
</p>





<!-- <a href="https://www.youtube.com/channel/UCTgLUneI3agkv_FcW0RlI0A"></a> -->
